import { createRoute } from "@tanstack/react-router";

import { requirePlatformAdmin } from "@platform/auth/guards";
import { shellRoute } from "@platform/shell.route";
import { AdminUsersPage } from "./users.page";

export const adminUsersRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/admin/users",
	beforeLoad: ({ context }) => requirePlatformAdmin(context.queryClient),
	component: AdminUsersPage,
});
